
const config = {
    defaultImg: 'https://srt-read-online.3ren.cn/headimg/15380393100165xkTSS6Iww.png?x-oss-process=image/resize,h_500', // 默认头像
    defaultLogo: 'https://d1.3ren.cn/static/front-res/grain-wand-web/web-logo.png' // 默认logo
}

export default config;